import { render } from "./AlertTriangleRed.vue?vue&type=template&id=72af82fb"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/AlertTriangleRed.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "72af82fb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('72af82fb', __exports__)) {
    api.reload('72af82fb', __exports__)
  }
  
  module.hot.accept("./AlertTriangleRed.vue?vue&type=template&id=72af82fb", () => {
    api.rerender('72af82fb', render)
  })

}


export default __exports__